import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ApiErrorResponse } from "../components/snack/interfaces/ApiErrorResponse";
import { SnackComponent } from "../components/snack/snack.component";
import { ApiVerb } from "../enums/apis/ApiVerb.enum";
import { ApiResult } from "../enums/core/ApiResult";

@Injectable({
  providedIn: 'root',
})
export class SnackService {

  readonly DELAY_SNACK = 4000;

  constructor(private _snackBar: MatSnackBar) {

  }

  /**
   * A utiliser si l'on ne veut as utiliser showDefault() pour plus de custom
   * @param message
   */
  show(message: ApiResult): void {
    this.openSnackBar(message, true);
  }

  private openSnackBar(message: ApiResult, quick: boolean) {
    const opts: MatSnackBarConfig = quick ? { duration: this.DELAY_SNACK } : {};
    opts.data = {
      message: message
    }
    opts.horizontalPosition = "center",
    opts.verticalPosition = "top",

    this._snackBar.openFromComponent(SnackComponent, opts);
  }
}
